import { apiClient } from "@/services/apiClient";

export interface FiscalProfileSnapshot {
  companyType: string | null;
  isExporter: boolean;
  hasEmployees: boolean;
  bpsCompanyNumber: string | null;
  taxpayerType: string | null;
  paysIVA: boolean | null;
  paysIRAE: boolean | null;
  paysBPS: boolean | null;
  taxes: string[];
  ivaFrequency: string | null;
  ivaRegime: string | null;
  /** Régimen especial (Res. DGI 1222/008). Orthogonal to ivaRegime. */
  specialRegime: string | null;
  iraeFrequency: string | null;
  fiscalYearEnd: string;
  activityStartDate: string;
}

export interface FiscalProfileRegistration {
  obligaciones: Array<{
    nombre: string;
    caracteristica?: string;
    fechaInicio?: string;
  }>;
  actividades: Array<{
    codigo: string;
    descripcion: string;
    esPrincipal: boolean;
  }>;
  tipoEntidad: string | null;
  grupo: string | null;
  fechaInicioActividades: string | null;
}

export interface FiscalProfileDerived {
  needsReview: boolean;
  reviewReasons: string[];
  derivedAt: string;
  trace: {
    companyTypeSource?: string;
    ivaRegimeSource?: string;
    isExporterSource?: string;
    taxpayerTypeSource?: string;
    fiscalYearEndSource?: string;
    obligacionesMatched?: Array<{ nombre: string; effects: string[] }>;
  };
}

export interface FiscalProfileResponse {
  profile: FiscalProfileSnapshot | null;
  registration: FiscalProfileRegistration | null;
  derived: FiscalProfileDerived | null;
}

export function getFiscalProfile(tenantId: string): Promise<FiscalProfileResponse> {
  return apiClient
    .get<FiscalProfileResponse>(`/platform/tenants/${tenantId}/fiscal-profile`)
    .then((r) => r.data);
}

export function rederiveFiscalProfile(
  tenantId: string,
): Promise<{ needsReview: boolean; reviewReasons: string[]; matched: string[] }> {
  return apiClient
    .post<{ needsReview: boolean; reviewReasons: string[]; matched: string[] }>(
      `/platform/tenants/${tenantId}/fiscal-profile/derive`,
    )
    .then((r) => r.data);
}
